import { Currency } from '@/core/currency/interfaces';

const SLL: Currency = {
    name: 'Sierra Leonean Leone',
    demonym: 'Sierra Leonean',
    majorSingle: 'Leone',
    majorPlural: 'Leones',
    codeNumeric: '694',
    symbol: 'Le',
    symbolNative: 'Le',
    minorSingle: 'Cent',
    minorPlural: 'Cents',
    ISOdigits: 2,
    decimals: 2,
    numToBasic: 100,
    code: 'SLL',
    delimiters: {
        thousands: '.',
        decimal: ','
    }
};

export default SLL;
